import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_condicionpago_id: new EntityColumn<string>({ name: 'c_condicionpago_id', type: 'char', length: 20, flags: c.PK, prompt: 'Condición de pago ID' }),
        vc_descripcion: new EntityColumn<string>({ name: 'vc_descripcion', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Descripción' }),
        i_dias: new EntityColumn<number>({ name: 'i_dias', type: 'int', flags: c.Edit, prompt: 'Dias' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        cdpg_brwStandard: { name: 'cdpg_brwStandard', keyMappings: { c_condicionpago_id: 0 } }
    }
)

export class CondicionesPagoDef extends EntityDefinition {

    columns = columns();
    views = views();

    constructor() {
        super('CondicionesPago');
    }
}